import { writable, derived } from "svelte/store";
import { diccionario } from "../i18n/dicc";

const idiomas = ['es','ca','en'];

const nav = navigator.language?.slice(0,2);
const idiomaInicial = (() => {
  const guardado = localStorage.getItem("idioma");
  if (guardado && idiomas.includes(guardado)) return guardado;

  const navegador = navigator.language?.slice(0, 2);
  if (idiomas.includes(navegador)) return navegador;

  return "es"; // idioma por defecto
})();

export const idioma = writable(idiomaInicial);
idioma.subscribe((value) => {
  localStorage.setItem("idioma", value);
});
export const textos = derived(idioma, $idioma => diccionario[$idioma]);